import useSuspenseQuery from 'commons/useSuspenseQuery';
import useUserData from 'data-hooks/useUserData';
import { GET_FAVORITED_PRODUCT_IDS } from 'mocks/queries';

const DEFAULT_RESPONSE = { data: { productIds: [] } };

const useFavoritedProductIds = (options = {}) => {
  const { isLoggedIn } = useUserData();

  const response = useSuspenseQuery(GET_FAVORITED_PRODUCT_IDS, {
    ...options,
    skip: !isLoggedIn || options.skip,
  });

  return isLoggedIn ? response : DEFAULT_RESPONSE;
};

export default useFavoritedProductIds;
